import styles from "./section.module.scss";
import Stack from "@mui/material/Stack";
import classnames from "classnames";
import PropTypes from "prop-types";

export const Main = ({ children, className, fullHeight, ...props }) => {
  return (
    <Stack
      className={classnames(styles.main, className, {
        [styles.fullHeight]: fullHeight,
      })}
      component="main"
      useFlexGap
      {...props}
    >
      {children}
    </Stack>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  sx: PropTypes.object,
};
